/**
 * 批量注册组件
 */
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'

const structure = (app: any): any => {
    const requireComponent = require.context(
        // 其组件目录的相对路径
        '../components',
        // 是否查询其子目录
        true,
        // 匹配基础组件文件名的正则表达式
        /\.vue$/
    )

    requireComponent.keys().forEach((fileName: any) => {
        // 获取组件配置
        const componentConfig = requireComponent(fileName)

        // 获取组件的 PascalCase 命名
        const componentName: string = upperFirst(
            camelCase(
                // 剥去文件名开头的 `./` 和结尾的扩展名
                fileName.replace(/^\.\/(.*)\.\w+$/, '$1').split('/').pop()
            )
        )
        // 全局注册组件
        app.component(
            componentName,
            // 如果这个组件选项是通过 `export default` 导出的，
            // 那么就会优先使用 `.default`，
            // 否则回退到使用模块的根。
            componentConfig.default || componentConfig
        )
    })
}

export { structure }
